<template>
  <div>
    <v-title>
      {{ isNew ? 'New Delivery Address' : 'Address Detail' }}
    </v-title>
    <v-card>
      <v-card-text>
        <v-card>
          <ValidationObserver ref="observer">
            <v-container grid-list-md>
              <v-layout v-if="isNew" wrap>
                <v-flex>
                  <vonex-text
                    ref="contactName"
                    v-model="updateContact.ContactName"
                    label="Name"
                    name="contactName"
                    :rule="'required'"
                  />
                </v-flex>
                <v-flex>
                  <vonex-text
                    ref="contactEmail"
                    v-model="updateContact.contactEmail"
                    label="ContactEmail"
                    name="contactEmail"
                    :rule="'email'"
                  />
                </v-flex>
                <v-flex>
                  <vonex-text
                    ref="contactMobile"
                    v-model="updateContact.contactMobile"
                    label="Mobile"
                    name="contactMobile"
                    :rule="'mobilenumber'"
                  />
                </v-flex>
              </v-layout>
              <v-form v-model="valid">
                <v-layout wrap>
                  <v-flex sm12 md12 lg12>
                    <vonex-autocomplete
                      ref="streetAddress"
                      v-model="streetAddress"
                      :items="
                        results.filter(
                          (x) => !x.formatted_address.includes(`PO BOX`)
                        )
                      "
                      label="Search for physical street Address, not PO Box"
                      :search-input.sync="search"
                      item-text="formatted_address"
                      item-value="formatted_address"
                      :filter="customFilter"
                      persistent-hint
                      :browser-autocomplete="
                        isGoogleChrome ? 'disabled' : 'off'
                      "
                      :rule="'required'"
                      @change="addrLookup"
                    ></vonex-autocomplete>
                  </v-flex>
                  <v-flex sm6 md6 lg6>
                    <vonex-text
                      ref="streetAddress"
                      v-model="streetAddress"
                      :disabled="true"
                      name="streetAddress"
                      label="Street Address"
                      :rule="'required'"
                      :options="fieldConditions"
                    ></vonex-text>
                  </v-flex>
                  <v-flex sm6 md6 lg6>
                    <vonex-text
                      ref="suburb"
                      v-model="suburb"
                      :disabled="true"
                      name="suburb"
                      label="Suburb"
                      :rule="'required'"
                      :options="fieldConditions"
                    ></vonex-text>
                  </v-flex>
                  <v-flex sm3 md3 lg3>
                    <vonex-text
                      ref="state"
                      v-model="state"
                      :disabled="true"
                      name="state"
                      label="State"
                      :rule="'required'"
                      :options="fieldConditions"
                    ></vonex-text>
                  </v-flex>
                  <v-flex sm3 md3 lg3>
                    <vonex-text
                      ref="postCode"
                      v-model="postCode"
                      data-cy-post-code
                      :disabled="true"
                      name="postCode"
                      label="Postcode"
                      :rule="'required|numeric'"
                      :options="fieldConditions"
                    ></vonex-text>
                  </v-flex>
                </v-layout>
              </v-form>
            </v-container>
            <v-card-actions>
              <v-btn color="primary" @click="addCustomerAddress">Save</v-btn>
              <v-btn color="light-grey" @click="$emit('close')">Close</v-btn>
            </v-card-actions>
          </ValidationObserver>
        </v-card>

        <message-alert :component="address.message"></message-alert>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import { createNamespacedHelpers } from 'vuex';
import { mapAddressFields, mapCustomerFields } from '../store/modules/orders';
const { mapState: mapOrderState } = createNamespacedHelpers(`orders`);
const { mapActions: mapAddressActions, mapMutations: mapAddressMutations } =
  createNamespacedHelpers(`orders/address`);
const { mapActions: mapCustomerActions } =
  createNamespacedHelpers(`orders/customer`);

export default {
  props: {
    add: { type: Boolean, required: true },
    isNew: { type: Boolean, required: false },
  },
  computed: {
    ...mapAddressFields(['results']),
    ...mapOrderState(['company', 'customer', 'address', 'isGrenke']),
    ...mapCustomerFields({
      custid: 'customer.customerID',
      addrID: 'customer.addressID',
    }),
    ...mapGetters('orders', ['isQantas', 'orderID']),
    isGoogleChrome() {
      return (
        /Chrome/.test(navigator.userAgent) &&
        /Google Inc/.test(navigator.vendor)
      );
    },
    destination() {
      if (this.isQuote) return 'create-ipvoice';
      else if (this.isQantas && !this.customer.customer.isGuarantor && !this.allFlags.SOG8484)
        return 'create-contacts';
      return 'direct-debit';
    },
  },
  data() {
    return {
      valid: false,
      isDataLoading: false,
      isSaved: false,
      addressID: null,
      postCode: null,
      state: null,
      streetAddress: null,
      suburb: null,
      customerID: null,
      isSubmittedSuccessfully: false,
      isLoaded: false,
      search: '',
      updateContact: {
        name: null,
        company: null,
        mobile: null,
      },
    };
  },

  mounted() {
    let vm = this;
    this.$nextTick(() => {
      this.setResults([]);
      if (this.add == true) {
        this.customerID = this.custid;
      } else {
        if (this.addrID) {
          this.getAddress(this.addrID).then((data) => {
            vm.fillFields(data);
          });
        }
      }
    });
  },
  methods: {
    ...mapActions('orders', ['saveContact']),
    ...mapAddressActions([
      'resetAddress',
      'getAddress',
      'addAddress',
      'updateAddress',
      'addAddressToCust',
      'updateAddressToCust',
      'searchAddress',
      'completeAddress',
    ]),
    ...mapCustomerActions(['addCustomerToUB', 'getCustomer']),
    ...mapAddressMutations(['setResults']),
    addCustomerAddressToList(address) {
      vm.$emit('closeForList', address);
    },
    addrLookup(val) {
      let vm = this;
      this.completeAddress(val).then((addr) => {
        vm.fillFields(addr);
      });
    },
    fillFields(address) {
      this.streetAddress = address.streetAddress;
      this.suburb = address.suburb;
      this.state = address.state;
      this.postCode = address.postCode;
    },
    addCustomerAddress: function (event) {
      let vm = this;
      vm.isSubmittedSuccessfully = false;
      vm.$refs.observer.validate().then((result) => {
        if (vm.$store.getters['orders/changeLessee/createOnly'])
          vm.$store.commit(
            'orders/changeLessee/setProcessingChangeOfLesse',
            true
          );
        if (result) {
          if (vm.add) {
            if (vm.addressID > 0) {
              vm.updateAddress(vm.custid).then(function () {
                vm.isProcessingAddress = false;
                if (vm.isNew) {
                  vm.saveContact({
                    orderID: vm.orderID,
                    contact: vm.updateContact,
                  }).then((contact) => {
                    vm.$emit('updateContact', contact);
                  });
                  vm.$emit('updateContact', vm.updateContact);
                }

                vm.$emit('close', vm.addressID);
                return;
              });
            } else {
              vm.addAddress(vm.custid)
                .then((data) => {
                  vm.isProcessingAddress = false;
                  if (vm.isNew) {
                    vm.saveContact({
                      orderID: vm.orderID,
                      contact: vm.updateContact,
                    })
                      .then((contact) => {
                        vm.$emit('updateContact', contact);
                      })
                      .finally((_) => {
                        vm.$emit('close', data.addressID);
                      });
                  }
                })
                .catch((err) => {
                  resolve(err);
                });
            }
          } else {
            if (vm.addrID > 0)
              vm.updateAddressToCust().then(() => {
                vm.isProcessingAddress = false;
                if (vm.isQantas) vm.$emit('added', vm.destination);
              });
            else {
              vm.addAddressToCust()
                .then(() => {
                  if (vm.$store.getters['orders/changeLessee/createOnly']) {
                    vm.$store
                      .dispatch('orders/customer/addCustomerToUB')
                      .then((data) => {
                        let customer =
                          vm.$store.getters[
                            'orders/customer/getCurrentCustomer'
                          ];

                        vm.$store
                          .dispatch(
                            'orders/customer/getCustomer',
                            customer.customerID
                          )
                          .then((data) => {
                            vm.$store.commit(
                              'orders/changeLessee/setProcessingChangeOfLesse',
                              false
                            );
                            vm.$store.dispatch(
                              'orders/changeLessee/assignNewCustomer',
                              data
                            );
                            vm.$router.push(`change-lessee`);
                          })
                          .catch((e) => {})
                          .finally(() => {
                            vm.$store.commit(
                              'orders/changeLessee/setProcessingChangeOfLesse',
                              false
                            );
                          });
                      });
                  } else {
                    if (vm.isQantas) vm.$emit('added', vm.destination);
                    vm.getCustomer(this.customer.customer.customerID);
                  }
                })
                .catch((err) => {});
            }
            return;
          }
        }
      });
    },

    clearDropdown: function (e) {
      let vm = this;
      vm.results = [];
    },
    customFilter(item, queryText, itemText) {
      return true;
    },
  },
  watch: {
    search(val) {
      if (val !== null) {
        if (val.length > 5) this.searchAddress(val);
      }
    },
  },
};
</script>